module.exports = __webpack_public_path__ + "files/91ee2036cb2d6bc7e784ba1587aa6996.png";